/* eslint-disable @typescript-eslint/no-explicit-any */
import { Market } from "@thenounproject/lingo-core";
import remove from "lodash/remove";

import createEntityReducer from "../helpers/createEntityReducer";
import { getEntitiesFromAction, mergeEntitiesIfChanged } from "../helpers/mergeIfChanged";
import { deleteMarket } from "@redux/actions/markets/useDeleteMarket";
import { fetchMarkets } from "@redux/actions/markets/useMarkets";

export default createEntityReducer<Market>(
  "markets",
  queryBuilder => {
    queryBuilder.addCase(deleteMarket.fulfilled, (state, action) => {
      const marketId = action.payload.result;
      const { spaceId } = action.meta.arg;
      fetchMarkets.getQueryData(state, { spaceId }).forEach(query => {
        if (!query.data) return;
        const removed = remove(query.data.markets, id => id === marketId);
        query.data.total -= removed.length;
      });
    });
  },
  objectBuilder => {
    objectBuilder.addDefaultCase((state, action: any) => {
      const markets = getEntitiesFromAction<Market>(action, "markets");
      return mergeEntitiesIfChanged(state, markets);
    });
  }
);
